import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import handleFileSelection from '../helpers/FileSelection';
import {
  addSelectedFile,
  removeSelectedFile,
} from '../actions/Files';

const withFileSelection = (WrappedComponent) => {
  class WithFileSelection extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        lastSelectedIndex: null,
      };

      this.handleFileSelect = this.handleFileSelect.bind(this);
    }

    handleFileSelect(fileUuid, isSelected) {
      const { files, selectFile, unselectFile } = this.props;
      const { lastSelectedIndex } = this.state;
      const { event } = window;

      const newLastSelectedIndex = handleFileSelection(
        files,
        fileUuid,
        isSelected,
        lastSelectedIndex,
        selectFile,
        unselectFile,
        event,
      );

      this.setState({ lastSelectedIndex: newLastSelectedIndex });
    }

    render() {
      return (
        <WrappedComponent
          {...this.props}
          onFileSelect={
            (fileUuid, isSelected) => this.handleFileSelect(fileUuid, isSelected)
          }
        />
      );
    }
  }

  WithFileSelection.propTypes = {
    files: PropTypes.array.isRequired,
    selectFile: PropTypes.func.isRequired,
    unselectFile: PropTypes.func.isRequired,
  };

  const mapDispatchToProps = dispatch => ({
    selectFile: (file) => {
      dispatch(addSelectedFile(file));
    },
    unselectFile: (fileUuid) => {
      dispatch(removeSelectedFile(fileUuid));
    },
  });

  return connect(null, mapDispatchToProps)(WithFileSelection);
};

export default withFileSelection;
